import heroBg from "@images/api/hero-bg.jpg";
import worldMap from "@images/api/world-map.jpg";
import iconCard from "@images/api/icon-card.jpg";
import iconWallet from "@images/api/icon-wallet.jpg";
import iconChart from "@images/api/icon-chart.jpg";
import iconReceipt from "@images/api/icon-receipt.jpg";
import iconSliders from "@images/api/icon-sliders.jpg";
import iconBell from "@images/api/icon-bell.jpg";
import iconPadlock from "@images/api/icon-padlock.jpg";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "ApiPage",
  computed: {
    ...walletVuex.mapState(["isMobile"])
  },
  data() {
    const share = [{
      icon: "icon-telegram",
      type: "telegram"
    }, {
      icon: "icon-x",
      type: "x"
    }, {
      icon: "icon-discord",
      type: null
    }, {
      icon: "icon-youtube"
    }];
    const capabilities = [{
      icon: iconCard,
      title: this.$lang("Virtual Card Issuance"),
      desc: this.$lang("Create and issue virtual Visa cards through API.")
    }, {
      icon: iconWallet,
      title: this.$lang("Card Funding"),
      desc: this.$lang("Fund virtual cards and manage card balances through API.")
    }, {
      icon: iconChart,
      title: this.$lang("Balance Inquiry"),
      desc: this.$lang("Query card and account balance information.")
    }, {
      icon: iconReceipt,
      title: this.$lang("Transaction Records"),
      desc: this.$lang("Retrieve card transaction records and payment status.")
    }, {
      icon: iconSliders,
      title: this.$lang("Card Management"),
      desc: this.$lang("Manage card status and supported card operations.")
    }, {
      icon: iconBell,
      title: this.$lang("Webhook Notifications"),
      desc: this.$lang("Receive real-time notifications for supported card and transaction events.")
    }, {
      icon: iconPadlock,
      title: this.$lang("Secure API Authentication"),
      desc: this.$lang("Securely connect your system to MPay API services with controlled API access.")
    }];
    const useCases = [this.$lang("Online purchases"), this.$lang("Subscriptions"), this.$lang("Software and platforms"), this.$lang("Advertising services"), this.$lang("Other supported online payments")];
    const features = [{
      text: this.$lang("Secure API authentication"),
      dotClass: "dot-purple"
    }, {
      text: this.$lang("Encrypted data transmission"),
      dotClass: "dot-cyan"
    }, {
      text: this.$lang("Controlled API access"),
      dotClass: "dot-purple"
    }, {
      text: this.$lang("Transaction status tracking"),
      dotClass: "dot-cyan"
    }, {
      text: this.$lang("Webhook event notifications"),
      dotClass: "dot-purple"
    }, {
      text: this.$lang("Structured card and transaction management"),
      dotClass: "dot-cyan"
    }];
    return {
      share,
      heroBg,
      worldMap,
      contactEmail: "mpay.mpaycard@gmail.com",
      capabilities,
      useCases,
      features,
      tipInstance: null
    };
  },
  methods: {
    onSkip(type) {
      let url = null;
      if (!type) return;
      switch (type) {
        case "gw":
          url = "https://t.me/MpayCardBot";
          break;
        case "telegram":
          url = "https://t.me/MpayCardBot";
          break;
        case "x":
          url = "https://x.com/MpayCard";
          break;
        case "m_telegram":
          url = "https://t.me/MpayCardBot/?startapp=ref_sXPbRd5";
          break;
        case "m_browser":
          url = "https://app.mpay.cards?startapp=ref_sXPbRd5";
          break;
        case "m_line":
          url = "https://liff.line.me/2008536228-j92Lno4E?startapp=ref_sXPbRd5";
          break;
      }
      console.log("urlurlurlurlurl", url);
      if (!url) return;
      open(url, "target");
    },
    contactEmailFnc() {
      const url = `https://mail.google.com/mail/?view=cm&fs=1` + `&to=${encodeURIComponent(this.contactEmail)}`;
      window.open(url, "_blank");
    },
    onCopy() {
      this.$copyText(this.contactEmail).then(e => {
        const showTip = () => {
          this.$nextTick(() => {
            this.tipInstance = this.$tip({
              target: this.$refs.Copiedref,
              // 参考元素
              content: this.$lang("Copied!")
            });
            console.log("this.tipInstance", this.tipInstance);
          });
          setTimeout(() => this.tipInstance.hiddenTip(), 1500);
        };
        showTip();
      }, function (e) {});
    }
  }
};